import instructorReducer from './instructor';
import onlineClassReducer from './onlineClass';


export const instructor = instructorReducer;
export const onlineClass = onlineClassReducer;